import { CONFIG_UPDATE } from '~/reducers/config/types';
import { generateUserAgentHeader, urls } from '~/utilities/dataHelpers';
import mediator from '~/utilities/mediator';
import { store } from '~/utilities/store';

type ConfigArgs = {
  compatibility: boolean;
  country?: string;
  appVersion?: string;
  deviceManufacturer?: string;
  deviceModel?: string;
  osType?: string;
  osVersion?: string;
  deviceId?: string;
};

const getConfig = async ({
  compatibility,
  country,
  appVersion,
  deviceManufacturer,
  deviceModel,
  osType,
  osVersion,
  deviceId,
}: ConfigArgs) => {
  const result = await mediator.request<ApiResponse<Config>>('api:invoke', {
    method: 'GET',
    url: `${urls.apiUrl}config`,
    headers: {
      'X-User-Agent': generateUserAgentHeader({
        appVersion,
        osType,
        osVersion,
      }),
      'X-Device-ID': deviceId,
    },
    params: {
      country,
      compatibility,
      deviceManufacturer,
      deviceModel,
    },
  });

  if (result.data) {
    return result.data;
  }

  throw result;
};

export const updateConfig = async ({
  compatibility,
  country = 'US',
  appVersion,
  deviceManufacturer = 'none',
  deviceModel = 'none',
  osType,
  osVersion,
  deviceId,
}: ConfigArgs) => {
  const config = await getConfig({
    compatibility,
    country,
    appVersion,
    deviceManufacturer,
    deviceModel,
    osType,
    osVersion,
    deviceId,
  });

  store.dispatch({ type: CONFIG_UPDATE, config });
};
